import React from 'react';

// **text** → <strong> 파싱 (white-space: pre-line과 함께 동작)
function renderWithBold(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
}

const CareerItem = ({ text, isHighlight, showDivider, mobile }) => (
  <li className="list-none m-0 p-0 flex flex-col">
    <span
      className="font-pretendard font-medium text-[#262626]"
      style={{ fontSize: mobile ? 14 : 20, lineHeight: mobile ? '20px' : '29px', letterSpacing: '-0.04em' }}
    >
      ㅡ
    </span>
    <span
      className={`font-pretendard font-medium ${isHighlight ? 'font-bold text-[#3261ae]' : 'text-[#262626]'}`}
      style={{
        fontSize: mobile ? 14 : 20,
        lineHeight: mobile ? '20px' : '135%',
        letterSpacing: '-0.04em',
        whiteSpace: 'pre-line',
      }}
    >
      {renderWithBold(text)}
    </span>
  </li>
);

const CareerList = ({ careerItems = [], mobile = false }) => {
  if (!careerItems.length) {
    return (
      <p className="font-pretendard text-[#888] m-0" style={{ fontSize: mobile ? 14 : 20 }}>
        등록된 경력 정보가 없습니다.
      </p>
    );
  }
  return (
    <ul className="flex flex-col m-0 p-0" style={{ gap: mobile ? 6 : 20 }}>
      {careerItems.map((item, idx) => (
        <CareerItem key={idx} text={item.text} isHighlight={item.isHighlight} showDivider={idx > 0} mobile={mobile} />
      ))}
    </ul>
  );
};

export default CareerList;
